const ACTION_TYPES = {
  ON_CREATE_JIRA_REQUEST_CLICK: 'ON_CREATE_JIRA_REQUEST_CLICK',
  ON_TEST_SESSION_ID_CLICK: 'ON_TEST_SESSION_ID_CLICK',
};

export default ACTION_TYPES;
